/** Required policy acknowledgement with an accessible inline reminder. */
if (!customElements.get('terms-checkbox')) {
  customElements.define('terms-checkbox', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      const checkbox = this.querySelector('input[type="checkbox"]');
      const button = this.parentNode.querySelector('.button.checkout-button');
      if (!checkbox || !button) return;
      const message = document.createElement('p');
      message.className = 'aim-cart-error';
      message.id = `${checkbox.id}-error`;
      message.setAttribute('role', 'alert');
      message.hidden = true;
      this.append(message);
      checkbox.setAttribute('aria-describedby', message.id);
      const validate = event => {
        if (checkbox.checked) return;
        event.preventDefault();
        message.textContent = theme.strings.requiresTerms;
        message.hidden = false;
        checkbox.setAttribute('aria-invalid', 'true');
        checkbox.focus();
      };
      button.addEventListener('click', validate, { signal });
      button.form?.addEventListener('submit', validate, { signal });
      checkbox.addEventListener('change', () => {
        message.hidden = true;
        checkbox.removeAttribute('aria-invalid');
      }, { signal });
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  });
}
